import styled from 'styled-components'

const Wrapper = styled.div`
  width: 100%;
`

const Section = styled.section`
  display: flex;
  align-items: flex-start;
  margin-bottom: 30px;
  padding-left: 40px;
  gap: 16px;

  @media (max-width: 1180px) {
    flex-direction: column;
    gap: 20px;
  }
`
const Container = styled.div`
  margin-bottom: 30px;
`

const FlexBlock = styled.div`
  display: flex;
`

const LeftColumn = styled.div`
  flex: 2 1 0%;
  min-width: 550px;
  width: 100%;

  @media (min-width: 1440px) {
    // max-width: calc(66.666% - 8px);
  }

  @media (min-width: 1181px) and (max-width: 1439px) {
    // max-width: calc(60% - 8px);
  }

  @media (max-width: 1180px) {
    max-width: 100%;
  }
`

const RightColumn = styled.div`
  flex: 1 1 0%;
  min-width: 355px;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding-top: 32px;
  box-sizing: border-box;
  position: sticky;
  top: 150px;
  align-self: flex-start;
  z-index: 10;
  height: calc(100vh - 64px - 150px - 24px);
  max-height: calc(100vh - 64px - 150px - 24px);

  @media (max-width: 1180px) {
    position: relative;
    top: auto;
    padding-top: 0;
    height: auto;
    max-height: none;
    min-width: 0;
    max-width: 100%;
  }
`
const SectionTitle = styled.h2`
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 0;
  line-height: 100%;
  color: var(--color-text-black);
`
const CardSubtitle = styled.h3`
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 0;
  line-height: 28px;
  color: var(--color-text-black);
`
const Card = styled.div`
  margin-top: 14px;
  padding: 20px;
  background-color: white;
  border-radius: 20px;
  box-shadow: 0px 2px 10px 2px rgba(110, 110, 110, 0.06);
`

// Overview cards layout: side-by-side above 1300px, stacked at/below 1300px (existing UI)
const OverviewCards = styled.div`
  @media (min-width: 1301px) {
    display: flex;
    align-items: stretch;
    gap: 16px;

    & > div:first-child {
      flex: 1 1 auto;
      min-width: 0;
    }
    & > div + div {
      flex: 0 0 300px;
    }
  }
`

// Overview-specific layout additions
const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 30px;
`

const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  color: var(--color-text-black);
`

const IconCircle = styled.div`
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: var(--color-issabeline-grey);
  display: inline-flex;
  align-items: center;
  justify-content: center;
`
const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(2, 1fr);
    row-gap: 24px;
  }
  @media (max-width: 580px) {
    grid-template-columns: repeat(2, 1fr);
    row-gap: 24px;
  }
`

const StatItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding-left: 0;
  position: relative;
  & + & {
    border-left: 1px solid var(--color-issabeline-grey);
    padding-left: 24px;
  }
  @media (max-width: 1200px) {
    &:nth-child(2n + 1) {
      border-left: none;
      padding-left: 0;
    }
    &:nth-child(2n) {
      border-left: 1px solid var(--color-issabeline-grey);
      padding-left: 24px;
    }
  }
  @media (max-width: 1335px) {
    & + & {
      // padding-left: 12px;
    }
  }
  @media (max-width: 1024px) {
    & + & {
      border-left: none;
      padding-left: 0;
    }
  }
`

const StatContent = styled.div`
  display: flex;
  flex-direction: column;
`

const StatLabel = styled.span`
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 0rem;
  line-height: 24px;
  color: var(--color-text-secondary);
  white-space: nowrap;
`

export {
  Wrapper,
  Section,
  FlexBlock,
  LeftColumn,
  RightColumn,
  SectionTitle,
  CardSubtitle,
  Card,
  OverviewCards,
  HeaderRow,
  HeaderLeft,
  IconCircle,
  StatsGrid,
  StatItem,
  StatContent,
  StatLabel,
  Container,
}
